import React from 'react';
import classnames from 'classnames';
import Layout from "../../../../core/layout";
import { widths, sizes, textAlignments } from "../../../../../enums";
import { Avatar, Logo, NetworkActions, SharingContent } from "../common";
import SharingConstants from "../../constants";

var TwitterSharePreviewTemplate = function TwitterSharePreviewTemplate(p) {
  var _classnames;

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('sharing-schematic-preview', (_classnames = {}, _classnames["preview-" + p.network] = p.network, _classnames))
  }, /*#__PURE__*/React.createElement(Layout, {
    columns: widths.ONE
  }, /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.FOURTEEN
  }, /*#__PURE__*/React.createElement(Avatar, {
    title: SharingConstants.PREVIEW_CONFIG[p.name].userName,
    byline: SharingConstants.PREVIEW_CONFIG[p.name].handle,
    network: p.network,
    name: p.name
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.TWO,
    textAlign: textAlignments.RIGHT
  }, /*#__PURE__*/React.createElement(Logo, {
    network: p.network,
    size: sizes.X2
  }))), /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(SharingContent, {
    network: p.network,
    message: p.previewData.message
  })), /*#__PURE__*/React.createElement(Layout.Row, {
    columns: widths.TWO
  }, /*#__PURE__*/React.createElement(Layout.Column, null, /*#__PURE__*/React.createElement(NetworkActions, {
    network: p.network
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    textAlign: textAlignments.RIGHT
  }, /*#__PURE__*/React.createElement("div", {
    className: "sharing-date"
  }, SharingConstants.PREVIEW_DATE)))));
};

export default TwitterSharePreviewTemplate;
//# sourceMappingURL=twitter.js.map